import React, {lazy} from 'react';
import {Route, Routes} from 'react-router-dom';

const PAGE_404 = lazy(() => import('pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	/*const { company } = useMst();*/

	// [2025.06.25] contentRoutes 분리
	let contents;
	if(process.env.REACT_APP_ENV?.includes('hyosung')){
		contents = require('hyosung/routes/contentRoutes').default;
	}else if(process.env.REACT_APP_ENV === 'saas-prod'){
		contents = require('routes/contentRoutes').default;
	}else if(process.env.REACT_APP_ENV === 'uat'){
		contents = require('routes/contentRoutes').default;
		/*if(company?.id !== 28){
			contents = require('hyosung/routes/contentRoutes').default;
		}else{
			contents = require('routes/contentRoutes').default;
		}*/
	}else{
		contents = require('routes/contentRoutes').default;
	}

	return (
		<Routes>
			{contents.map((page) => {
				return <Route key={page.path} {...page} />;
			})}
			<Route path="*" element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
